import React, { useEffect, useMemo } from "react";

import { Button, Form, Input, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";

export interface ProcessLogDetailsProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function MergeRequestBrandProcessLogModal(props: ProcessLogDetailsProps) {
  const processLog = useSelector(
    (state: RootState) =>
      state.livePlatformState.duplicateBrandState
        .mergedDuplicateBrandProcessLogDetails.data
  );
  
  const [form] = Form.useForm();

  const handleModalClose = () => {
    props.close();
  };

  useEffect(() => {
    if (processLog) {
      form.setFieldsValue({
        CreatedAt: processLog.createdAt,
        Message: processLog.message,
        Description: processLog.description?.replaceAll("|||", "\n"),
      });
    }
  }, [processLog, form]);

  //ModalContent
  const ProcessLogDetailsModalContent = useMemo(() => {
    return (
      <div className="d-flex flex-column gap-4">
        <h4>Process Log Details</h4>

        <Form
          form={form}
          name="processLogForm"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 24 }}
          style={{ maxWidth: 600 }}
          labelAlign={"left"}
        >
          <Form.Item label="Created At" name="CreatedAt" colon={false}>
            <Input readOnly={true} />
          </Form.Item>
          <Form.Item label="Message" name="Message" colon={false}>
            <Input readOnly={true} />
          </Form.Item>
          <Form.Item label="Description" name="Description" colon={false}>
            <TextArea autoSize={{ minRows: 3, maxRows: 7 }} readOnly={true} />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 21 }}>
            <Button type="primary" htmlType="button" onClick={handleModalClose}>
              Close
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }, [form]);

  return (
    <Modal
      centered
      zIndex={1500}
      footer={[]}
      width={600}
      onCancel={handleModalClose}
      open={props.openState}
      styles={{
        mask: {
          backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
        content: {
          boxShadow: "none",
        },
      }}
    >
      {ProcessLogDetailsModalContent}
    </Modal>
  );
}

export default MergeRequestBrandProcessLogModal;
